export const chatScreen = {
	autoSuggStyle: '',
	bgStyle: '',
	videoBg: '',
};
